import { render, staticRenderFns } from "./UserEmailDrawerContent.vue?vue&type=template&id=458d10f1&scoped=true&"
import script from "./UserEmailDrawerContent.vue?vue&type=script&lang=js&"
export * from "./UserEmailDrawerContent.vue?vue&type=script&lang=js&"
import style0 from "./UserEmailDrawerContent.vue?vue&type=style&index=0&id=458d10f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458d10f1",
  null
  
)

export default component.exports